import * as actions from './actions';
import { TOKEN_TTL_MS } from 'constants.js';

const initialState = {
  loading: false,
  licensesLoading: true,
  ready: false,
  username: null,
  current: {},
  tenants: [],
  supportedTenant: {
    isGetting: false,
    list: []
  },
  tenantDefaultPermissions: [],
  contexts: [],
  selectedTenant: {},
  loggedTenant: {},
  selectedBusinessContext: {},
  selectedRowsPerPage: 10,
  samlToken: null,
  xToken: null,
  hasPasswordExpired: null,
  forgotView: 'forgotPasswordUsername',
  forgotData: null,
  question: null,
  error: {
    message: null,
    raw: null,
    response:null
  },
  adsamlDetails: {},
  licensesData: {},
  licensePlan: '',
  features: [],
  licenseFailed: false,
  gettingLicenseFailed: false,
  logoDetails: null,
  supportUserOptions: [],
  isSupportUserSelected: false,
  refreshSession: false,
  loginDetails: {},
  isContextLoading: false,
  tenantDetails: {},
};
function buildContextTree(contexts) {
  let roots = [],
    children = {};
  // find the top level root nodes and set levels based on their path
  contexts.forEach(context => {
    let target;
    if (context.parentId) {
      target = children[context.parentId] || (children[context.parentId] = []);
      context.path = context?.path
        ?.substring(1, context.path.length - 1)
        .split(',');
      context.level = context.path.length + 1;
    } else {
      target = roots;
      context.level = 1;
    }
    target.push(context);
  });
  // function to recursively find the children
  let findChildren = function(parent) {
    if (children[parent.businessContextId]) {
      parent.children = children[parent.businessContextId];
      for (let i = 0, len = parent.children.length; i < len; ++i) {
        findChildren(parent.children[i]);
      }
    }
  };
  roots.forEach(root => {
    findChildren(root);
  });
  let contextTree = [];
  // function to recursively flatten the results into an array
  const getVal = rootElements => {
    rootElements.forEach(element => {
      element.level = element.level - 1;
      contextTree.push(element);
      if (element.children?.length > 0) {
        getVal(element.children);
      }
    });
  };
  getVal(roots);
  return contextTree;
}

function getContext(
  state,
  businessContextId,
  details,
  isSupportUser,
  contextRoles,
  supportUserPermissions
) {
  let validContexts = [];
  let roles;
  if(state.loggedTenant.tenantType === 'SERVICE_ACCOUNT') {
    roles = state.selectedTenant.tenantId === state.loggedTenant.tenantId ? details.contextRoles : details.thirdPartyTenantContextRoles ? details.thirdPartyTenantContextRoles[state.selectedTenant.tenantId] : [];
  } else {
    roles = details.contextRoles;
  }
  let contextWithRoles = roles?.filter(
    context =>
      (context.roles || []).indexOf('ADM_ADMIN') >= 0 ||
      (context.roles || []).indexOf('ADM_USER') >= 0 ||
      (context.roles || []).indexOf('ADM_ROLE') >= 0
  );
  let contextIds = (contextWithRoles || []).map(context => context.contextId);
  let selectedBusinessContext = [];
  if (state.contextDetails) {
    let contextDetails = [
      { businessContextId: 'Default', name: 'ALL', level: 0 },
      ...state.contextDetails
    ];
    validContexts = contextDetails
      .filter(
        context =>
          contextIds.indexOf('Default') >= 0 ||
          contextIds.indexOf(context.businessContextId) >= 0 ||
          (context?.path || []).filter(id => contextIds.indexOf(id) >= 0)
            ?.length > 0
      )
      ?.map(context => context.businessContextId);
    let contextId =
      businessContextId ||
      contextWithRoles?.find(context => context.contextId === 'Default')
        ?.contextId ||
      validContexts[0];
    selectedBusinessContext = contextDetails.find(
      context => context.businessContextId === contextId
    ) || { businessContextId: businessContextId };
    let permissionList;
    if(state.loggedTenant.tenantType === "SERVICE_ACCOUNT" && state.selectedTenant.tenantId !== state.loggedTenant.tenantId) {
      permissionList = state.loginDetails?.thirdPartyTenantContextPermissions ? state.loginDetails?.thirdPartyTenantContextPermissions[selectedBusinessContext?.businessContextId] : [];
    } else if(state.loggedTenant.tenantId === "0" && state.selectedTenant.tenantId !== state.loggedTenant.tenantId ) {
      permissionList = state.loggedTenant.defaultPermissions || [];
    } else if(selectedBusinessContext) {
      permissionList = state.loggedTenant.contextResponses?.filter(context => context.contextId === selectedBusinessContext?.businessContextId)[0]?.permissions;
    }         
     selectedBusinessContext = {
      permissions: permissionList,
      ...selectedBusinessContext
    };
  }
  return {
    selectedBusinessContextTemp: selectedBusinessContext,
    validContextsTemp: validContexts
  };
}

function getSelectedBusinessContext(state, action) {
  let selectedTenant, selectedBusinessContext;
  if (state.selectedTenant.isSupportUser) {
    selectedTenant = state.selectedTenant;
    let contextRoles = state.selectedTenant.contextRoles.filter(
      context => context.contextId === action.businessContextId
    );
    selectedBusinessContext = getContext(
      state,
      action.businessContextId,
      state.loginDetails,
      true,
      contextRoles,
      selectedTenant.defaultPermissions
    ).selectedBusinessContextTemp;
  } else {
    selectedTenant = state.selectedTenant;
    selectedBusinessContext = getContext(
      state,
      action.businessContextId,
      state.loginDetails
    ).selectedBusinessContextTemp;
  }
  return {
    selectedBusinessTemp: selectedBusinessContext,
    selectectedTenantTemp: selectedTenant
  };
}
function getErrorMessage(action) {
  let error = initialState.error;
  if (action.error.userMessage?.hasPasswordExpired) {
    error = initialState.error;
  } else {
    error = {
      message: action.error.userMessage,
      raw: action.error
    };
  }
  return error;
}
function getMessageCondition(actionSendCodeMode) {
  return actionSendCodeMode === 'sms'
    ? 'There was a problem sending the code to your phone.'
    : 'There was a problem sending the code to your email.';
}
export default (state = initialState, action) => {
  let selectedTenant;
  let selectedBusinessContext;
  let selectedRowsPerPage;
  let error;
  let validContexts = [];
  switch (action.type) {
    case actions.LOG_IN:
      return {
        ...state,
        adminMessage: null,
        error: null,
        username: action.username
      };
    case actions.SSO_LOG_IN:
      return {
        ...state,
        samlToken: action.token
      };
    case actions.REFRESH_TOKEN_SUCCEEDED:
      return {
        ...state
      };
    case actions.LOG_OUT:
    case actions.LOGGING_IN:
    case actions.LOGGING_OUT:
      return {
        ...state,
        loading: true
      };
    case actions.LOGGING_IN_SUCCEEDED:
      return {
        ...state,
        error: initialState.error,
        hasPasswordExpired: initialState.hasPasswordExpired,
        current: action.user,
        xToken: action.user.token,
        tenants: action.user.tenants,
        selectedTenant: action.user.tenants[0],
        loggedTenant: action.user.tenants[0],
        tenantDefaultPermissions: action.user.tenants[0].defaultPermissions,
        validContexts: action?.user?.tenants[0]?.contextResponses.map(
          context => context.contextId
        )
      };
    case actions.SUPPORT_USER_LOGIN_SUCCEEDED:
      selectedTenant = action.user.tenants.find(
        tenant => tenant.tenantId === action.user.selectedTenantId
      );
      let {
        selectedBusinessContextTemp: selectedBusinessDraft,
        validContextsTemp: validContextDraft
      } = getContext(
        state,
        action?.user?.businessContextId || state.loginDetails.businessContextId,
        state.loginDetails,
        true,
        action?.user?.tenants[0]?.contextRoles,
        selectedTenant.defaultPermissions
      );
      validContexts = validContextDraft;
      selectedBusinessContext = selectedBusinessDraft;
      return {
        ...state,
        error: initialState.error,
        hasPasswordExpired: initialState.hasPasswordExpired,
        current: action.user,
        xToken: action.user.token,
        tenants: action.user.tenants,
        selectedTenant,
        loggedTenant: action.user.tenants[0],
        tenantDefaultPermissions:
          selectedTenant.defaultPermissions[
            selectedBusinessContext.businessContextId
          ],
        validContexts,
        selectedBusinessContext
      };
    case actions.INITIALIZE_LOGIN:
    case actions.LOGGING_OUT_SUCCEEDED:
      return {
        ...initialState,
        loading: false
      };
    case actions.LOGGING_IN_FAILED:
      error = getErrorMessage(action);
      return {
        ...state,
        error,
        hasPasswordExpired: action.error.userMessage?.hasPasswordExpired,
        loading: false
      };
    case actions.LOGGING_OUT_FAILED:
      return {
        ...initialState,
        error: action.error,
        loading: false
      };
    case actions.SET_SELECTED_TENANT:
      selectedTenant = state.supportedTenant.list.find(
        t => t.tenantId === action.tenantId
      ) || { tenantId: action.tenantId };
      return {
        ...state,
        selectedTenant,
        isContextLoading: true
      };
    case actions.SET_SELECTED_BUSINESSCONTEXT:
      let { selectedBusinessTemp, selectectedTenantTemp } = getSelectedBusinessContext(
        state,
        action
      );
      selectedBusinessContext = selectedBusinessTemp;
      selectedTenant = selectectedTenantTemp;
      return {
        ...state,
        selectedBusinessContext,
        selectedTenant
      };
    case actions.SET_ROWS_PER_PAGE:
      selectedRowsPerPage = action.rowsPerPage;
      return {
        ...state,
        selectedRowsPerPage
      };
    case actions.LOGIN_READY:
      return {
        ...state,
        ready: true
      };
    case actions.CHECK_ADSAML:
      return {
        ...state,
        adsamlDetails: {
          ...state.adsamlDetails,
          tenantId: action.tenantId
        }
      };
    case actions.CHECKING_ADSAML_SUCCEEDED:
      return {
        ...state,
        adsamlDetails: {
          ...state.adsamlDetails,
          isAdsamlEnabled: action.isAdsamlEnabled
        }
      };
    case actions.CHECKING_ADSAML_FAILED:
      return {
        ...state,
        error: {
          message: {
            instructions: action.msg
          }
        }
      };
    case actions.UPDATE_ADSAML_DETAILS:
      return {
        ...state,
        adsamlDetails: {
          ...state.adsamlDetails,
          ...action.adsamlDetails
        }
      };
    case actions.RESET_PASSWORD:
      return {
        ...state,
        error: initialState.error,
        updatedPassword: action.updatedPassword,
        adminMessage: null
      };
    case actions.RESET_PASSWORD_FAILED:
      return {
        ...state,
        error: {
          message: action.error.userMessage,
          raw: action.error
        }
      };
    case actions.REFRESH_PASSWORD_EXPIRATION:
      return {
        ...state,
        error: initialState.error,
        hasPasswordExpired: initialState.hasPasswordExpired
      };
    case actions.FORGOT_PASSWORD:
      return {
        ...initialState,
        username: action.username,
        adminMessage: null
      };
    case actions.FORGOT_USERNAME:
      return {
        ...initialState,
        adminMessage: null
      };
    case actions.SEND_FORGOT_PASSWORD:
      return {
        ...state,
        adminMessage: null
      };
    case actions.FORGOT_PASSWORD_SUCCEEDED:
      return {
        ...state,
        forgotData: action.data
      };
    case actions.FORGOT_USERNAME_SUCCEEDED:
      return {
        ...state,
        adminMessage: {
          success: true,
          message: action.contactType
        }
      };
    case actions.GET_SECURITY_QUESTION:
      return {
        ...state,
        isLoading: true
      };
    case actions.GET_SECURITY_QUESTION_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        forgotView: 'securityQuestions',
        question: action?.question[0]
      };
    case actions.SEND_FORGOT_PASSWORD_SUCCEEDED:
      return {
        ...state,
        adminMessage: action.data
      };
    case actions.GET_AUTHENTICATION:
      return {
        ...state,
        loginData: action.loginData,
        currentView: 'getAuth',
        userName: action.loginData.username,
        isSendCodeFailed: false
      };
    case actions.SEND_CODE_THROUGH_SMS:
    case actions.SEND_CODE_THROUGH_EMAIL:
    case actions.RESET_ADMIN_MESSAGE:
      return {
        ...state,
        adminMessage: null,
        error: {}
      };
    case actions.UPDATE_SEND_CODE_STATUS:
      return {
        ...state,
        adminMessage: {
          ...(action.sendCodeStatus !== 'Error' && {
            success: true,
            isSendCodeMessage: true,
            message:
              action.sendCodeMode === 'sms'
                ? 'A security code has been sent to the phone number registered for this user (' +
                  state.userName +
                  ').'
                : 'A security code has been sent to the email registered for this user (' +
                  state.userName +
                  ').'
          }),
          ...(action.sendCodeStatus === 'Error' && {
            success: false,
            isSendCodeMessage: true,
            message: getMessageCondition(action.sendCodeMode)
          })
        }
      };
    case actions.PROCEED_AUTHENTICATION_FAILED:
      return {
        ...state,
        currentView: 'adminMessage',
        adminMessage: {
          success: false,
          message:
            action.error.message || action.error.userMessage?.instructions
        },
        isSendCodeFailed: true
      };
    case actions.FORGOT_PASSWORD_FAILED:
    case actions.FORGOT_USERNAME_FAILED:
    case actions.GET_SECURITY_QUESTION_FAILED:
    case actions.SEND_FORGOT_PASSWORD_FAILED:
      return {
        ...state,
        adminMessage: {
          success: false,
          message:
            action.error.message || action.error.userMessage?.instructions
        },
        isLoading: false
      };
    case actions.REFRESH_TOKEN:
      return {
        ...state,
        refreshSession: false
      };
    case actions.REFRESH_SESSION_TOKEN:
      return {
        ...state,
        refreshSession: true
      };
    case actions.SESSION_START:
      return {
        ...state,
        xTokenExpires: Date.now() + TOKEN_TTL_MS,
        refreshSession: false
      };

    case actions.REFRESH_TOKEN_FAILED:
      return {
        ...state,
        error: action.error
      };
    case actions.GETTING_LICENSES_SUCCEEDED:
      let plan = Object.keys(action.data.licenses);
      return {
        ...state,
        licensesData: action.data,
        licensePlan: plan,
        features: action.data.licenses[plan],
        gettingLicenseFailed: false,
        licensesLoading: false
      };
    case actions.GETTING_LICENSES_FAILED:
      return {
        ...state,
        features: [],
        licenseFailed: action.hasNoLicense || action.error.hasNoLicense,
        gettingLicenseFailed: !action.error.hasNoLicense,
        licensesLoading: false,
        errorOccurred: action.error.errorOccurred
      };
    case actions.GETTING_LOGO_DETAILS_SUCCEEDED:
      return {
        ...state,
        logoDetails: action.data
      };
    case actions.GET_SUPPORT_USER_DETAILS:
      return {
        ...state,
        supportedTenant: {
          isGetting: true,
          list: []
        },
        isLoading: true
      };
    case actions.GETTING_SUPPORT_USERS_SUCCEEDED:
      return {
        ...state,
        supportUserOptions: action.data,
        supportedTenant: {
          isGetting: false,
          list: action.data.map(tenant => ({ tenantId: tenant.value, name: tenant.label })).sort((a, b) => a.name.localeCompare(b.name))
        },
        isSupportUserSelected: false,
        gettingLicenseFailed: false,
        isLoading: false
      };
    case actions.SUPPORT_USER_SELECTED:
      return {
        ...state,
        isSupportUserSelected: true,
        isLoading: true,
        licensesLoading: true
      };
    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case actions.SET_CONTEXT_DETAILS:
      let contextDetails = buildContextTree(action.details);
      if (state.selectedTenant.tenantId === state.loginDetails?.tenantId) {
        const { selectedBusinessContextTemp, validContextsTemp } = getContext(
          state,
          action.businessContextId,
          state.loginDetails
        );
        selectedBusinessContext = selectedBusinessContextTemp;
        validContexts = validContextsTemp;
      } else {
        selectedBusinessContext = state.selectedBusinessContext;
        validContexts = state.validContexts;
      }
      return {
        ...state,
        contextDetails,
        selectedBusinessContext,
        validContexts,
        isContextLoading: false
      };
    case actions.GETTING_LOGIN_DETAILS_SUCCEEDED:
      const { selectedBusinessContextTemp, validContextsTemp } = getContext(
        state,
        action.businessContextId || action.details.businessContextId,
        action.details
      );
      return {
        ...state,
        loginDetails: action.details,
        selectedBusinessContext: selectedBusinessContextTemp,
        validContexts: validContextsTemp
      };
    case actions.GET_TENANT_LIST:
      return {
        ...state,
        supportedTenant: {
          isGetting: true,
          list: []
        },
      }
    case actions.GETTING_TENANT_LIST_SUCCEEDED:
      let tenantList = action.details.length === 0 
        ? [{ tenantId: state.loggedTenant.tenantId, name: state.loggedTenant.tenantName }] 
        : action.details
      return {
        ...state,
        supportedTenant: {
          isGetting: false,
          list: tenantList.sort((a, b) => a.name.localeCompare(b.name))
        },
        selectedTenant: tenantList.find(
          t => t.tenantId === state.selectedTenant.tenantId
        ) || { tenantId: state.selectedTenant.tenantId }
      }
    case actions.GETTING_TENANT_LIST_FAILED:
      return {
        ...state,
        supportedTenant: {
          isGetting: false,
          list: []
        },
        error: {
          message: action.payload
        }
      }

    case actions.GETTING_TENANT_DETAILS_SUCCEEDED:
      return {
        ...state,
        tenantDetails: action.data
      }
    default:
      return state;
  }
};
